import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
// import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '../core/core.module';
import { LoaderComponent } from './loader/loader.component';
import { PopupComponent } from './popup/popup.component';

@NgModule({
	imports: [
		CommonModule,
		CoreModule,
		// FormsModule,
		// ReactiveFormsModule,
		TranslateModule.forChild()
	],
	declarations: [
		LoaderComponent,
		PopupComponent
	],
	providers: [],
	exports: [
		LoaderComponent,
		PopupComponent
	]
})
export class SharedModule {
}
